import type { Locale } from '@packages/config';

export const getNavigationDataEndpoint = (
  dataBucket: string,
  clientId: string,
  channel: string,
  locale: Locale,
  sliced: boolean,
  deploymentEnv = 'current',
): string => {
  const isFr = locale.includes('fr') ? '_fr' : '';
  const formattedClientID = clientId.toLowerCase();
  const version = '0';
  const slicedVersion = sliced ? '_sliced' : '';

  return `${dataBucket}${deploymentEnv && deploymentEnv !== 'current' ? `-${deploymentEnv}` : ''}/${formattedClientID}_${channel}${isFr}_${version}${slicedVersion}.json`;
};
